var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"\n      pa-lg-8 pa-sm-2\n      login-wrapper\n      justify-center\n      align-center\n      w-100\n      h-100\n      d-flex\n    "},[_c('SelectUser')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }